export default __webpack_public_path__ + "static/media/mic.0f0d7300.svg";